import { SendInterval } from './Constants'
import dayjs from 'dayjs'
import Encode from '@/constants/encode'
import Account from '@/api/account'

const dateFormat = 'YYYY-MM-DD'

export class IntervalReportNotification {
  constructor(item = {}, isActive) {
    const {
      sendInterval = SendInterval.DAILY,
      emails = [],
      closingDate = this.defaultClosingDate,
      encode = Encode.SHIFT_JIS,
    } = item
    this.sendInterval = sendInterval
    this.emails = emails
    this.closingDate = this.makeClosingDate(isActive, closingDate)
    this.encode = encode
  }

  get defaultClosingDate() {
    return dayjs(new Date())
      .add(6, 'month')
      .format(dateFormat)
  }

  async setEmails() {
    if (this.emails.length === 0) {
      const res = await Account.getMe()
      this.emails = [res.item.email]
    }
  }

  makeClosingDate(isActive, closingDate) {
    return isActive ? closingDate : this.defaultClosingDate
  }

  isValid(isActive) {
    if (isActive) {
      return (
        Object.values(SendInterval).includes(this.sendInterval) &&
        Object.values(Encode).includes(this.encode) &&
        this.isValidEmails() &&
        this.closingDate !== null
      )
    }
    return true
  }

  isValidEmails() {
    return this.emails.length > 0 && this.isValidEmailsFormat()
  }

  isValidEmailsFormat() {
    const regexp = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/
    for (let i = 0; i < this.emails.length; i++) {
      if (!regexp.test(this.emails[i])) {
        return false
      }
    }
    return true
  }
}
